/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_HOLDERS_LIST: {
    size: 10,
    skip: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.holdersPage.getHolders',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_HOLDERS_LIST' },
      },
    },
    GET_HOLDERS_LIST: {
      invoke: {
        id: 'holdersList',
        src: 'holdersList',
        onDone: {
          target: 'RENDER_HOLDERS_LIST',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_HOLDERS_LIST_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_HOLDERS_LIST: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_HOLDERS_LIST',
        },
      },
    },
    RENDER_HOLDERS_LIST_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
